// REACT
import React from 'react';

// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';
// COMPONENTS

import ServiceSalesFlow from './ServiceSalesFlow/ServiceSalesFlow';

// UTILS
import { constants } from '../../constants';
import map from 'lodash/map';

class ServiceDetail extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            viewIndex: 0,
            showModal: false,
            provider: null,
            service: null,
            company: null,
            booking: null
        };
    }

    // ########## LIFE CYCLE HOOKS ############## //

        componentDidMount(){
            
            // Go to the top of the page on load
            document.getElementById('top').scrollIntoView();
            
            this.props.getDBProviders();
            this.props.getDBServices();
            this.props.getDBProviderCompanies();
            this.props.getDBServiceCategories();
            this.props.getDBServiceModules();
            this.props.getServiceModules(this.props.match.params.id); // This is called here so that athe resulting redux data can be used in ServiceDetailViews
        }
        
        componentWillReceiveProps(nextProps) {
            this.getProviderCompanyService(nextProps);
        }

    // ########################################### //

    handleChangeViewIndex = (index) => {
        if (index) {
            this.setState({
                viewIndex: index
            });
        }
    }

    getProviderCompanyService = (props) => {
        if (props.dbProviders && props.services && props.companies) {
            // console.log(`%cdbPROVIDERS OBJECT SHOLD BE ARRAY${JSON.stringify(props.dbProviders)}`,'color: greenyellow');
            return props.dbProviders.map((provider)=> {
                // console.log(`%c${JSON.stringify(provider.uid)} ${JSON.stringify(props.match.params.id)}`,'color: deeppink');
                return props.services.map(service => {
                    if (service._id === props.match.params.id) {
                        return props.companies.map(company => {
                            if (company._id === service.company) {
                                if (provider.uid === service.provider) {
                                    // console.log('MATCH FOUND FOR PROVIDER');
                                    // console.log(provider, company, service, 'PROCOMSER PRESENT?');
                                    this.setState({
                                        provider,
                                        service,
                                        company
                                    }, ()=>{
                                        this.props.setSelectedService(service);
                                        // console.log('getting cal from serv detail');
                                        // props.getCalendar(provider.SBMId, service.SBMId);
                                    })
                                }
                            }
                        })
                    }
                })
            });
        } else {
            // console.error('NO EXPERT FOUND at getExpert()');
            return null;
        }
    }

    // getNRandomNumbers = (min, max, n) => {
    //     let arr = [];
    //     while(arr.length < (n + 1)){
    //         const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min
    //         if(arr.indexOf(randomNumber) > -1) continue;
    //         arr[arr.length] = randomNumber;
    //         console.log(arr);
    //     }
    //     return arr;
    // }

    // handleOpenVideoModal = () => {
    //     this.setState({ showModal: true });
    // }

    // handleCloseVideoModal = () => {
    //     this.setState({ showModal: false });
    //     console.log('CLOSE VIDEO HAS RUN');
    // }

    getDateToday = () => {
        let today = new Date();
        let dd = today.getDate();
        let mm = today.getMonth()+1; //January is 0!

        const yyyy = today.getFullYear();
        if(dd<10){
            dd='0'+dd;
        }
        if(mm<10){
            mm='0'+mm;
        }
        const date = mm+'-'+dd+'-'+yyyy;

        return date;
    }

    getModuleDescriptions = () => {
        if (this.props.serviceModules) {
            return this.props.serviceModules.map(module => {
                return module.description;
            });
            // TODO: NEED TO REDO THE LIST COMPONENT SO IT CAN HANDLE DESCRIPTION AND ID AND ICON NOW JUST PASSING IN DESCRIPTION
        }
    };

    setBookingData = ({thisWeekStartDate, serviceId, providerId, time, date, index, selectedProviderData}) => {
        this.setState({
            booking: {
                thisWeekStartDate,
                serviceId,
                providerId,
                time,
                date,
                index,
                selectedProviderData
            }
        }, (nextState)=>{
            
            document.getElementById('top').scrollIntoView();
            
            this.handleChangeViewIndex(2);

            // Load Selection Data into Gloabl State Storage
            this.props.setBookingProvider({...selectedProviderData, providerId});
            this.props.setBookingDetails({date, time});
            this.props.setBookingService(this.state.service);
        })
    }

    render(){
        // const expert = this.getExpert();
        const dateToday = this.getDateToday();
        const { provider, service, company } = this.state;
        // console.log(this.state.expert);
        // console.log(provider, service, company, 'is PROVIDER ###');
        const moduleDescriptionArray = this.getModuleDescriptions();

        console.log('MODULES DESCRIOTIONS', moduleDescriptionArray);
        
        return (
            <div className="ServiceDetailMainDiv" style={{...constants.layout.container, justifyContent: 'space-between'}}>
                { provider && service && company &&
                    <div>
                        <ServiceSalesFlow 
                            serviceId={(this.props.match && this.props.match.params && this.props.match.params.id) ? this.props.match.params.id : null}
                        />
                    </div>
                }
            </div>
        );
    }
};

const mapStateToProps = ({provider, service, company, auth, client, booking}) => {
    // console.log(`%cTHIS IS THE CLIENT: ${JSON.stringify(client)}`,'color: greenyellow');
    console.log('SERVICE MODULES', service.modules);
    console.log('SELECTED SERVICE @ SERVICE DETAIL', service.selectedService);
    
    
    return {
        // userData: client.clientData // NOT USED
        // userId: (auth.authData) ? auth.authData.id : null // NOT USED
        dbProviders: provider.providers,
        services: service.services,
        serviceCategories: service.categories,
        serviceModules: service.modules,
        companies: company.providerCompanies,
        // sbmProvider: booking.provider, // NOT USED
        // serviceDetailModules: service.modules,
    };
};

// const mapDispatchToProps = () => {
    
// };

export default connect(mapStateToProps, actions)(ServiceDetail)



// WEBPACK FOOTER //
// ./src/js/containers/ServiceContainer/ServiceDetail.jsx